import dedent from 'dedent';

export interface AppInfo {
  version?: string;
  date?: string;
  commit?: string;
}

export function appInfo(): AppInfo {
  return {
    version: typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : undefined,
    date: typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : undefined,
    commit: typeof __BUILD_COMMIT__ !== 'undefined' ? __BUILD_COMMIT__ : undefined
  };
}

export function appInfoString(): string {
  const { version, date, commit } = appInfo();
  return dedent`
    CADET
    Version: ${version ?? 'unknown'}
    Date: ${date ?? 'unknown'}
    Commit: ${commit ?? 'unknown'}
  `;
}
